import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'terracotta' | 'gold' | 'indigo' | 'ivory';
  className?: string;
}
const tones: Record<string, string> = {
  terracotta: 'border-terracotta/35 bg-terracotta-light/70 text-terracotta-deep',
  gold: 'border-gold/45 bg-gold-soft/60 text-gold-ink',
  indigo: 'border-indigo/30 bg-indigo-light text-indigo-deep',
  ivory: 'border-ivory/25 bg-ivory/10 text-ivory'
};
export function Pill({
  children,
  tone = 'terracotta',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] ${tones[tone]} ${className}`} data-id="element-166" data-mp="1ewvr9abvl4la">
      {children}
    </span>;
}